import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ShComplexMapReadonlyFieldComponent } from '../complex-map-readonly-field/complex-map-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-complex-readonly-field',
    templateUrl: '../complex-map-readonly-field/complex-map-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShComplexReadonlyFieldComponent extends ShComplexMapReadonlyFieldComponent {}
